/**
 * Swaps the PDP free-shipping USP icon and copy from the selected variant's final (sale) price.
 */
(function () {
  function parsePrice(variant) {
    if (!variant || variant.price == null || variant.price === '') {
      return null;
    }

    const price = Number(variant.price);
    return Number.isFinite(price) ? price : null;
  }

  function updateBadges(root, variant) {
    const price = parsePrice(variant);

    root.querySelectorAll('[data-dynamic-free-shipping]').forEach((badge) => {
      const threshold = Number(badge.dataset.thresholdCents);
      const qualifies = price != null && Number.isFinite(threshold) && price >= threshold;

      badge.querySelectorAll('.shipping-swap').forEach((el) => {
        const isQualifiedState = el.classList.contains('shipping-swap--qualified');
        el.classList.toggle('hidden', isQualifiedState !== qualifies);
      });
    });
  }

  document.addEventListener('variant:change', (event) => {
    // Scoped to the product being viewed so a quick buy elsewhere on the page can't change it.
    const root = event.target?.closest?.('product-rerender');

    if (!root) {
      return;
    }

    updateBadges(root, event.detail?.variant);
  });
})();
